"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _symmetric = _interopRequireDefault(require("@antv/adjust/lib/symmetric"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _symmetric["default"];
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@antv/f2/lib/geom/adjust/symmetric.js
// module id = 395
// module chunks = 3